module.exports = __webpack_public_path__ + "static/favicon-13e04972de2b66d5dad1f751a25b6875.ico";